import { lazy } from "react";

const CompanyDetails = lazy(() => import("./CompanyDetails"));
const Documents = lazy(() => import("./Documents"));
const EsgKpi = lazy(() => import("./EsgKpi"));
const EsgProfile = lazy(() => import("./EsgProfile"));
const PeerAnalysis = lazy(() => import("./PeerAnalysis"));
// const ApiConnections = lazy(() => import("./ApiConnections"));
const PeerDocuments = lazy(() => import("./PeerDocuments"));

const companySetup = {
  0: () => <CompanyDetails />,
};

const dataSetup = {
  // 0: <ApiConnections />,
  0: () => <Documents />,
  1: () => <PeerDocuments />,
};

const esgDiagnosis = {
  0: () => <EsgProfile />,
  1: () => <EsgKpi />,
  2: () => <PeerAnalysis />,
  // 2: <Controversies />,
  // 3: <NoDataComponent mainTitle={"No Response"} />,
};

export { companySetup, dataSetup, esgDiagnosis };
